import { useGetCurrenciesQuery } from "api/TenantSlug/Currency/hooks.ts";
import { useMemo } from "react";

import CurrencyData = App.Data.CurrencyData;

export function useCurrencies() {
    const { data, isLoading, isError } = useGetCurrenciesQuery();

    const byId = useMemo<Record<number, CurrencyData>>(() => {
        if (!data?.currencies) return {};
        return data.currencies.reduce(
            (acc, cur) => {
                acc[cur.id] = cur;
                return acc;
            },
            {} as Record<number, CurrencyData>
        );
    }, [data?.currencies]);

    return {
        loading: isLoading,
        error: isError,
        map: byId,
        get: (id?: number | null) => (id != null ? byId[id] : undefined),
    };
}
